import { injectStyles } from '@bonanza-social/moonlight/lib/theme/index.utils';

import './index.css';

const injectedStyles = document.createElement('style');

injectedStyles.innerHTML = injectStyles();

document.head.appendChild(injectedStyles);

function setStyle() {
  if (window.innerHeight) {
    document.documentElement.style.setProperty(
      '--inner-height',
      `${window.innerHeight}px`,
    );
  }
}

setStyle();

window.addEventListener('resize', setStyle);

let portraitMediaQuery;

if (window.matchMedia) {
  portraitMediaQuery = window.matchMedia('(orientation: portrait)');
}

if (portraitMediaQuery && portraitMediaQuery.onchange) {
  portraitMediaQuery.onchange(setStyle);
} else if (screen.orientation) {
  screen.orientation.addEventListener('change', setStyle);
} else {
  window.addEventListener('orientationchange', setStyle);
}
